import l, { forwardRef as a, useState as y } from "react";
const c = ({
  children: t,
  element: n,
  innerRef: s,
  ...e
}) => {
  const [f, u] = y(!0), B = (o) => {
    u(!1), e.onMouseDown && e.onMouseDown(o);
  }, w = (o) => {
    u(!0), e.onBlur && e.onBlur(o);
  };
  return /* @__PURE__ */ l.createElement(
    n,
    {
      ...e,
      onMouseDown: B,
      onBlur: w,
      ref: s,
      style: f ? { ...e.style } : { ...e.style, outline: "none" }
    },
    t
  );
}, i = a((t, n) => /* @__PURE__ */ l.createElement(
  c,
  {
    ...t,
    element: "button",
    innerRef: n
  }
));
i.displayName = "Button";
const r = a((t, n) => /* @__PURE__ */ l.createElement(
  c,
  {
    ...t,
    element: "a",
    innerRef: n
  }
));
r.displayName = "Button";
const m = {
  Button: i,
  Anchor: r
};
export {
  m as N
};
